import {useIsPayOrderAppPage} from '@aboutyou/router';
import {useEffect} from 'react';
import {useIsCustomerSessionValid} from '../../Checkout/useIsCustomerSessionValid/useIsCustomerSessionValid';
import {useIsAuthenticatingLegacyApple} from '../hooks/useIsAuthenticatingSSO';
import {useLogoutHandler} from '../hooks/useLogoutHandler';
import {useRefetchIsCustomerSessionValidNextUpdate} from './utils/useRefetchIsCustomerSessionValidNextUpdate';

export const AuthenticationValidator = () => {
  const sessionValidity = useIsCustomerSessionValid();
  const {logout} = useLogoutHandler();

  const isAuthenticatingLegacyApple = useIsAuthenticatingLegacyApple();
  const isPayOrderAppPage = useIsPayOrderAppPage();

  useRefetchIsCustomerSessionValidNextUpdate();

  useEffect(() => {
    /**
     * Context:
     * - Sometimes if the user is logged-in, but his CO access token is invalid at the point of entering pages which require authentication (ex: Checkout Page),
     * we force show the authentication modal, to make them re-authenticate (done via: forceSessionRefresh flag in useAuthenticationPrompt hook).
     * ^ This gives them a chance to re-authenticate without being logged out.
     *
     * - Some login methods (ex: Legacy Apple SSO) needs the user to go out of the shop (Apple page) and come back to the shop to be able to complete the login.
     * This means its a "page reload" situation for us, where the user is still logged in, but the CO is invalid.
     * In this case, we should not logout the user while the code param is being validated.
     * We need to avoid logging them out while they are in the process of re-authenticating, as it would disrupt their flow.
     *
     * NOTE: This logic can be removed once we get rid of Legacy Apple Login
     */
    if (isAuthenticatingLegacyApple) {
      return;
    }

    if (isPayOrderAppPage) {
      // In Pay Order App Page we dont want to force logout the user if the session is invalid and redirect then to home page,
      // we want to handle a forced login in the pay order app and want the user to be able to login again if needed
      return;
    }

    if (sessionValidity.canAccessShop === false) {
      logout('sessionValidator');
    }
  }, [
    sessionValidity.canAccessShop,
    isAuthenticatingLegacyApple,
    isPayOrderAppPage,
    logout,
  ]);

  return null;
};
